(function(){(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing-calculator","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing-calculator","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/backing","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    if(basename==="/"&&segments.length>0){      var hasKnownRoute=knownRoutes.some(function(r){return r==="/"});      if(hasKnownRoute){        basename="/"+segments.join("/");      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=0;i<segments.length;i++){      var testPath="/"+segments.slice(i).join("/");      var isKnownRoute=knownRoutes.some(function(r){return testPath===r||testPath===r+"/"});      if(isKnownRoute){        basename=i===0?"/":"/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename;  }})();(function(){  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=segments.length;i>0;i--){      var testPath="/"+segments.slice(i).join("/");      var match=knownRoutes.some(function(r){return testPath===r||testPath.startsWith(r+"/")});      if(match){        basename="/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename===""?"/":basename;  }})();  if(!window.__ROUTER_BASENAME){    var path=window.location.pathname;    var knownRoutes=["/","/binding","/binding-length-calculator","/border","/skirt","/cost-estimator","/fabric-converter","/button-converter","/cover-hem-guide","/needle-guide","/precuts-converter","/flying-geese","/quilt-layout"];    var segments=path.split("/").filter(function(s){return s});    var basename="/";    for(var i=segments.length;i>0;i--){      var testPath="/"+segments.slice(i).join("/");      var match=knownRoutes.some(function(r){return testPath===r||testPath.startsWith(r+"/")});      if(match){        basename="/"+segments.slice(0,i).join("/");        break;      }    }    window.__ROUTER_BASENAME=basename===""?"/":basename;  }})();//Quick View

 

jQuery(document).ready(function () {

  /*jQuery.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {

    quickView();

  });*/

  quickView();

});



 

function quickView() {

  //jQuery(".quick-view").click(function () {
  jQuery(document).on("click", ".quick-view", function(e) {

    e.preventDefault();

    if (jQuery('#quick-view').length == 0){jQuery("body").append('<div id="quick-view"></div>');}

    var product_handle = jQuery(this).data('handle');

    jQuery('#quick-view').addClass(product_handle);

    var url_product = '/products/' + product_handle;

    jQuery.ajax({
    url: url_product,
    success: function(data) {
      data=jQuery(data).find('.qs_main_product_row');
      /* Products with a required option dropdown (metafield custom.option_dropdown_choices)
         need the full product form: this quick view posts id + qty only and matches variants
         by joining every <select>, so the dropdown would break it. Go to the product page. */
      if (data.find('[data-qs-option-dropdown]').length) { window.location.href = url_product; return; }
      jQuery('#quick-view').html(data);
      jQuery('#quick-view .product__media-item').first().addClass('is-active');
      openFancybox();
     }
    });
    
    /*
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

      var title = product.title;

      var type = product.type;

      var price = 0;

      var original_price = 0;

      var desc = product.description;

      var images = product.images;

      var variants = product.variants;

      var options = product.options;

      var url = '/products/' + product_handle;

      jQuery('.qv-product-title').text(title);

      jQuery('.qv-product-type').text(type);

      jQuery('.qv-product-description').html(desc);

      jQuery('.view-product').attr('href', url);

      var imageCount = jQuery(images).length;

      jQuery(images).each(function (i, image) {

        if (i == imageCount - 1) {

          var image_embed = '<div><img src="' + image + '"></div>';

          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

          jQuery('.qv-product-images').append(image_embed);

 

          jQuery('.qv-product-images').slick({

            'dots': false,

            'arrows': true,

            'respondTo': 'min',

            'useTransform': false

          }).css('opacity', '1');

 

        } else {

          image_embed = '<div><img src="' + image + '"></div>';

          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

          jQuery('.qv-product-images').append(image_embed);

        }

      });

      jQuery(options).each(function (i, option) {

        var opt = option.name;

        var selectClass = '.option.' + opt.toLowerCase();

        jQuery('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');

        jQuery(option.values).each(function (i, value) {

          jQuery('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');

        });

      });

      jQuery(product.variants).each(function (i, v) {

        if (v.inventory_quantity == 0) {

          jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');

          jQuery('.qv-add-to-cart').hide();

          jQuery('.qv-product-price').text('Sold Out').show();

          return true

        } else {

          price = parseFloat(v.price / 100).toFixed(2);

          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

          jQuery('.qv-product-price').text('$' + price);

          if (original_price > 0) {

            jQuery('.qv-product-original-price').text('$' + original_price).show();

          } else {

            jQuery('.qv-product-original-price').hide();

          }

          jQuery('select.option-0').val(v.option1);

          jQuery('select.option-1').val(v.option2);

          jQuery('select.option-2').val(v.option3);

          return false

        }

      });

    });
    */
 

    jQuery(document).on("change", "#quick-view select", function () {

      var selectedOptions = '';

      jQuery('#quick-view select').each(function (i) {

        if (selectedOptions == '') {

          selectedOptions = jQuery(this).val();

        } else {

          selectedOptions = selectedOptions + ' / ' + jQuery(this).val();

        }

      });

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

        jQuery(product.variants).each(function (i, v) {

          if (v.title == selectedOptions) {

            var price = parseFloat(v.price / 100).toFixed(2);

            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

            var v_qty = v.inventory_quantity;

            var v_inv = v.inventory_management;

            jQuery('.qv-product-price').text('jQuery' + price);

            jQuery('.qv-product-original-price').text('jQuery' + original_price);

            if (v_inv == null) {

              jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');

            } else {

              if (v.inventory_quantity < 1) {

                jQuery('.qv-add-button').prop('disabled', true).val('Sold Out');

              } else {

                jQuery('.qv-add-button').prop('disabled', false).val('Add to Cart');

              }

            }

          }

        });

      });

    });

    function openFancybox() {
    var isMobile = window.innerWidth < 750;
    var cartDrawerObserver = null;
    var qvCurrentIdx = 0;

    function initQVArrows() {
      var $wrapper = jQuery('#quick-view .product__media-wrapper');
      if (!$wrapper.length) return;
      jQuery('.qv-nav-arrow').remove();
      var $thumbBtns = jQuery('#quick-view .thumbnail-list button');
      if ($thumbBtns.length <= 1) return;
      $wrapper.append('<button class="qv-nav-arrow qv-nav-arrow--prev" aria-label="Previous image">&#10094;</button>');
      $wrapper.append('<button class="qv-nav-arrow qv-nav-arrow--next" aria-label="Next image">&#10095;</button>');
      jQuery(document).on('click.qvarrows', '.qv-nav-arrow--prev', function() {
        qvCurrentIdx = (qvCurrentIdx - 1 + $thumbBtns.length) % $thumbBtns.length;
        $thumbBtns.eq(qvCurrentIdx).trigger('click');
      });
      jQuery(document).on('click.qvarrows', '.qv-nav-arrow--next', function() {
        qvCurrentIdx = (qvCurrentIdx + 1) % $thumbBtns.length;
        $thumbBtns.eq(qvCurrentIdx).trigger('click');
      });
    }

    jQuery.fancybox({

      href: '#quick-view',

      maxWidth: 1280,

      maxHeight: isMobile ? 9999 : 840,

      fitToView: true,

      width: isMobile ? '98%' : '94%',

      height: isMobile ? '88%' : '82%',

      autoSize: false,

      showCloseButton : true,

      closeClick: false,

      openEffect: 'none',

      closeEffect: 'none',

      'beforeLoad': function () {

        var product_handle = jQuery('#quick-view').attr('class');

        jQuery(document).off('click.qvadd').on("click.qvadd", ".qv-add-button", function () {

          var qty = jQuery('.qv-quantity').val();

          var selectedOptions = '';

          var var_id = '';

          jQuery('#quick-view select').each(function (i) {

            if (selectedOptions == '') {

              selectedOptions = jQuery(this).val();

            } else {

              selectedOptions = selectedOptions + ' / ' + jQuery(this).val();

            }

          });

          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

            jQuery(product.variants).each(function (i, v) {

              if (v.title == selectedOptions) {

                var_id = v.id;

                processCart();

              }

            });

          });

          function processCart() {

            jQuery.post('/cart/add.js', {

              quantity: qty,

              id: var_id

            },

                        null,

                        "json"

                       ).done(function () {

              jQuery('.qv-add-to-cart-response').addClass('success').html('<span>' + jQuery('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');

            })

            .fail(function (jQueryxhr) {

              var data = jQueryxhr.responseJSON;

              jQuery('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);

            });

          }

        });

        jQuery('.fancybox-wrap').css('overflow', 'hidden !important');

      },

      'afterShow': function () {

        jQuery('#quick-view').hide().css('opacity', '1').fadeIn(function () {

          jQuery('.qv-product-images').addClass('loaded');
          initQVArrows();

        });

        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          cartDrawerObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
              if (m.attributeName === 'class' && drawer.classList.contains('active')) {
                jQuery.fancybox.close();
                // afterClose already disconnects and nulls the observer (fixed 10/29/2026: this threw on null).
                if (cartDrawerObserver) { cartDrawerObserver.disconnect(); cartDrawerObserver = null; }
              }
            });
          });
          cartDrawerObserver.observe(drawer, { attributes: true });
        }

      },

      'afterClose': function () {

        jQuery('#quick-view').removeClass().empty();
        jQuery(document).off('click.qvarrows');
        jQuery(document).off('click.qvadd');
        jQuery('.qv-nav-arrow').remove();

        if (cartDrawerObserver) {
          cartDrawerObserver.disconnect();
          cartDrawerObserver = null;
        }

      }

    }); } // end openFancybox

  });

};

 

jQuery(window).resize(function () {

  if (jQuery('#quick-view').is(':visible')) {

    jQuery('.qv-product-images').slick('setPosition');

  }

});